import { render, staticRenderFns } from "./bjTable.vue?vue&type=template&id=0abf9dab&scoped=true"
import script from "./bjTable.vue?vue&type=script&lang=js"
export * from "./bjTable.vue?vue&type=script&lang=js"
import style0 from "./bjTable.vue?vue&type=style&index=0&id=0abf9dab&prod&lang=less"
import style1 from "./bjTable.vue?vue&type=style&index=1&id=0abf9dab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abf9dab",
  null
  
)

export default component.exports